import { CLICK_ID_MAX_AGE_MS } from "./constants";
import type { ClickIds } from "./types";

export function isClickIdsFresh(clickIds: ClickIds, nowMs = Date.now()) {
  return nowMs - clickIds.capturedAt <= CLICK_ID_MAX_AGE_MS;
}

export function mergeClickIds(
  existing: ClickIds | null,
  incoming: ClickIds | null,
): ClickIds | null {
  if (!incoming) {
    return existing && isClickIdsFresh(existing) ? existing : null;
  }

  if (!existing || !isClickIdsFresh(existing)) {
    return incoming;
  }

  return {
    gclid: existing.gclid ?? incoming.gclid,
    gbraid: existing.gbraid ?? incoming.gbraid,
    wbraid: existing.wbraid ?? incoming.wbraid,
    capturedAt: existing.capturedAt,
  };
}
